import { render, staticRenderFns } from "./SelectFaceCanvas.vue?vue&type=template&id=68eb3d14&scoped=true&"
import script from "./SelectFaceCanvas.vue?vue&type=script&lang=js&"
export * from "./SelectFaceCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SelectFaceCanvas.vue?vue&type=style&index=0&id=68eb3d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb3d14",
  null
  
)

export default component.exports